import createKindeClient from '@kinde-oss/kinde-auth-pkce-js';

let kindeClient = null;

export const authState = $state({
  isAuthenticated: false,
  profile: null,
  permissions: null,
  roles: null,
  flags: {}
});

export async function initAuth() {
  console.log("[Auth] Starting authentication initialization flow...");

  const config = {
    client_id: __KINDE_CLIENT_ID__,
    domain: __KINDE_DOMAIN__,
    redirect_uri: window.location.origin,
    logout_uri: window.location.origin
  };

  kindeClient = await createKindeClient(config);

  const isAuth = await kindeClient.isAuthenticated();
  authState.isAuthenticated = isAuth;

  if (isAuth === true) {
    const rawUser = await kindeClient.getUser();
    const permissionsData = await kindeClient.getPermissions();
    const rolesClaim = await kindeClient.getClaim('roles');
    const flagsClaim = await kindeClient.getClaim('feature_flags');

    const flags = {};
    if (flagsClaim !== null && flagsClaim.value !== undefined) {
      for (const [key, data] of Object.entries(flagsClaim.value)) {
        flags[key] = data.v;
      }
    }

    // Normalize the user object: strip nulls and empty strings, force to
    // undefined
    const user = {
      id: rawUser.id !== null ? rawUser.id : undefined,
      email: rawUser.email !== null ? rawUser.email : undefined,
      given_name: rawUser.given_name !== null && rawUser.given_name !== '' ? rawUser.given_name : undefined,
      family_name: rawUser.family_name !== null && rawUser.family_name !== '' ? rawUser.family_name : undefined,
      picture: rawUser.picture !== null && rawUser.picture !== '' ? rawUser.picture : undefined
    };

    authState.profile = user;
    authState.permissions = permissionsData;
    authState.roles = rolesClaim !== null ? rolesClaim.value : null;
    authState.flags = flags;

    console.log("[Auth] Initialization complete. User is logged in:", user);
  } else {
    console.log("[Auth] Initialization complete. User is NOT logged in.");
  }
}

export async function login() {
  if (kindeClient !== null) {
    console.log("[Auth] Starting login flow...");
    await kindeClient.login();
  }
}

export async function register() {
  if (kindeClient !== null) {
    console.log("[Auth] Starting registration flow...");
    await kindeClient.register();
  }
}

export async function logout() {
  if (kindeClient !== null) {
    console.log("[Auth] Starting logout flow...");
    await kindeClient.logout();
  }
}

export async function getToken() {
  if (kindeClient !== null) {
    return await kindeClient.getToken();
  }
  return null;
}

// Helper function to safely retrieve feature flags
export function getFlag(flagName, defaultValue) {
  if (authState.flags !== null && authState.flags !== undefined) {
    if (authState.flags[flagName] !== undefined && authState.flags[flagName] !== null) {
      return authState.flags[flagName];
    }
  }
  return defaultValue;
}

// Helper function to safely check if the user holds a specific permission string
export function hasPermission(permissionString) {
  if (authState.permissions !== null && authState.permissions !== undefined) {
    if (authState.permissions.permissions !== undefined && Array.isArray(authState.permissions.permissions) === true) {
      return authState.permissions.permissions.includes(permissionString);
    }
  }
  return false;
}

export async function apiFetch(url, options = {}) {
  const token = await getToken();
  const headers = Object.assign({}, options.headers || {});

  if (token !== null && token !== undefined && token !== '') {
    headers['Authorization'] = 'Bearer ' + token;
  }

  const fetchOptions = Object.assign({}, options, { headers });
  return await fetch(url, fetchOptions);
}